<footer class="footer">
  <div class="container px-3 py-5">
    <div class="app-discovery py-4">
      <h4 class="app-discovery-title crnt-typography-heading-4 mb-3">Ontdek onze app</h4>
      <div class="app-badges d-flex gap-3">
        <a
          [href]="translationService.t().googlePlayUrl"
          class="app-badge"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/assets/google-play-store-logo.svg" alt="Download on Google Play" />
        </a>
        <a
          [href]="translationService.t().appStoreUrl"
          class="app-badge"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/assets/apple-store-logo.svg" alt="Download on App Store" />
        </a>
      </div>
    </div>
  </div>
  <div class="footer-bottom py-4">
    <div class="container px-3">
      <div class="row align-items-center">
        <div class="col-12 col-md-6">
          <div class="footer-logo">
            <img
              [src]="translationService.t().logoPathBottom"
              [alt]="brandName()"
              class="footer-logo-image"
            />
          </div>
        </div>
        <div class="col-12 col-md-6 d-flex justify-content-md-end mt-2 mt-md-0">
          <div class="copyright crnt-typography-body-functional">
            © {{ brandName() }} {{ currentYear() }}
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
